import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { wait } from '@packages/utils';

import {
  BoostCoveredAndNotCoveredTab,
  BoostHeader,
  Container,
  SpecifiedItemsList,
} from '@components';
import { useBoostDetailsStore, useModalStore } from '@store';
import { sendAnalyticsECommerce, sendAnalyticsEvent, sendAnalyticsPage } from '@utils';

export const BoostDetail = () => {
  const params = useParams();
  const boostId = params?.id;
  const boostDetails = useBoostDetailsStore(state => {
    const mandatoryBoostId = state?.mandatoryBoostDetails?.boostId;
    return mandatoryBoostId === boostId ? state.mandatoryBoostDetails : state.boostDetails;
  });
  const closeAllModals = useModalStore(state => state.closeAllModals);

  useEffect(() => {
    //navigating from modal to boost detail view needs to scroll top after the style from root html tag is removed
    (async () => {
      await wait(0);
      window.scrollTo(0, 0);
    })();

    closeAllModals();
  }, [closeAllModals]);

  useEffect(() => {
    sendAnalyticsECommerce('Product Viewed');
    sendAnalyticsEvent('Boost Selection Page View');
  }, []);

  useEffect(() => {
    sendAnalyticsPage('Trip Product Details Page Viewed', {
      productTitle: boostDetails?.template?.title,
      isMandatory: !!boostDetails?.isMandatory,
      isExtra: !boostDetails?.isMandatory,
    });
  }, [boostDetails?.isMandatory, boostDetails?.template?.title]);

  return (
    <div>
      <BoostHeader />
      <Container className="relative z-10 ">
        <BoostCoveredAndNotCoveredTab
          boostId={boostDetails?.boostId}
          header={<SpecifiedItemsList boostId={boostDetails?.boostId} />}
          className="px-0 pt-8"
          onChange={() => {
            sendAnalyticsEvent('Product details coverage toggled');
          }}
        />
      </Container>
    </div>
  );
};
